import Decimal from 'decimal.js'

Decimal.set({ precision: 20, rounding: Decimal.ROUND_HALF_UP })

const CURRENCY_SYMBOLS: Record<string, string> = {
  SGD: 'S$',
  USD: '$',
  MYR: 'RM',
  PHP: '₱',
  AUD: 'A$',
  INR: '₹',
  EUR: '€',
  GBP: '£',
}

export function formatPrice(amount: string | number, currency: string): string {
  const d = new Decimal(amount)
  const symbol = CURRENCY_SYMBOLS[currency] ?? currency + ' '
  return `${symbol}${d.toFixed(2)}`
}

/** discountType: 0 = percentage, 1 = flat */
export function calculateDiscount(
  original: string | number,
  discountType: number,
  discountValue: string | number,
): Decimal {
  const price = new Decimal(original)
  const value = new Decimal(discountValue)

  let result: Decimal
  if (discountType === 0) {
    // percentage
    result = price.minus(price.mul(value).div(100))
  } else {
    // flat
    result = price.minus(value)
  }

  return Decimal.max(result, 0)
}
